import { yodaCatalogueConstants } from "../constants";

const initialState = {
  loading: false,
  loadingNext: false,
  loadingFilters: false,
  catalogue: [],
  collectionFilterList: [],
  categoryFilterList: [],
  productTypeFilterList: [],
  closureFilterList: [],
  hoodFilterList: [],
  paddingFilterList: [],
  pocketsFilterList: [],
  reversibleFilterList: [],
  sleevesFilterList: [],
  colorFilterList: [],
  sizeFilterList: [],
  continuousFilterList: [],
  fittingFilterList: [],
  catalogueItemDetails: {},
  catalogueItemDetailsSwap: {},
  itemCatalog: {},
  currentPage: 1,
  size: 10,
  totalCount: 0,
  totalPages: 0,
};

const catalogueReducer = (state = initialState, action) => {
  let tmpItemCatalog = {};
  let tmpCatalogueItemDetails = {};

  switch (action.type) {
    case yodaCatalogueConstants.GETONE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaCatalogueConstants.GETONE_SUCCESS:
      tmpCatalogueItemDetails = { ...state.catalogueItemDetails };
      tmpCatalogueItemDetails[action.payload.productId] = action.payload.item;

      return {
        ...state,
        catalogueItemDetails: tmpCatalogueItemDetails,
        loading: false,
      };

    case yodaCatalogueConstants.GETONE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCatalogueConstants.GETONESWAP_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaCatalogueConstants.GETONESWAP_SUCCESS:
      tmpCatalogueItemDetails = { ...state.catalogueItemDetailsSwap };
      tmpCatalogueItemDetails[action.payload.productId] = action.payload.item;

      return {
        ...state,
        catalogueItemDetailsSwap: tmpCatalogueItemDetails,
        loading: false,
      };

    case yodaCatalogueConstants.GETONESWAP_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCatalogueConstants.GETONE_CATALOG_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaCatalogueConstants.GETONE_CATALOG_SUCCESS:
      tmpItemCatalog = { ...state.itemCatalog };
      tmpItemCatalog[action.payload.catalogId] = action.payload.item;

      return {
        ...state,
        itemCatalog: tmpItemCatalog,
        loading: false,
      };

    case yodaCatalogueConstants.GETONE_CATALOG_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCatalogueConstants.GETONESWAP_CATALOG_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaCatalogueConstants.GETONESWAP_CATALOG_SUCCESS:
      tmpItemCatalog = { ...state.itemCatalog };
      tmpItemCatalog[action.payload.catalogId] = action.payload.item;

      return {
        ...state,
        itemCatalog: tmpItemCatalog,
        loading: false,
      };

    case yodaCatalogueConstants.GETONESWAP_CATALOG_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCatalogueConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        catalogue: [],
      };

    case yodaCatalogueConstants.GETALL_SUCCESS:
      return {
        ...state,
        catalogue: action.payload.catalogue,
        currentPage: action.payload.currentPage,
        size: action.payload.size,
        totalCount: action.payload.totalCount,
        totalPages: action.payload.totalPages,
        loading: false,
      };

    case yodaCatalogueConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCatalogueConstants.ADDALL_REQUEST:
      return {
        ...state,
        loading: true,
        loadingNext: true,
      };

    case yodaCatalogueConstants.ADDALL_SUCCESS:
      return {
        ...state,
        catalogue: [...state.catalogue, ...action.payload.catalogue],
        currentPage: action.payload.currentPage,
        size: action.payload.size,
        totalCount: action.payload.totalCount,
        totalPages: action.payload.totalPages,
        loading: false,
        loadingNext: false,
      };

    case yodaCatalogueConstants.ADDALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        loadingNext: false,
      };

    case yodaCatalogueConstants.GETALLSWAP_REQUEST:
      return {
        ...state,
        loading: true,
        catalogue: [],
      };

    case yodaCatalogueConstants.GETALLSWAP_SUCCESS:
      return {
        ...state,
        catalogue: action.payload.catalogue,
        currentPage: action.payload.currentPage,
        size: action.payload.size,
        totalCount: action.payload.totalCount,
        totalPages: action.payload.totalPages,
        loading: false,
      };

    case yodaCatalogueConstants.GETALLSWAP_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCatalogueConstants.ADDALLSWAP_REQUEST:
      return {
        ...state,
        loading: true,
        loadingNext: true,
      };

    case yodaCatalogueConstants.ADDALLSWAP_SUCCESS:
      return {
        ...state,
        catalogue: [...state.catalogue, ...action.payload.catalogue],
        currentPage: action.payload.currentPage,
        size: action.payload.size,
        totalCount: action.payload.totalCount,
        totalPages: action.payload.totalPages,
        loading: false,
        loadingNext: false,
      };

    case yodaCatalogueConstants.ADDALLSWAP_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        loadingNext: false,
      };

    case yodaCatalogueConstants.GETFILTERS_REQUEST:
      return {
        ...state,
        loadingFilters: true,
      };

    case yodaCatalogueConstants.UPDATE_FILTERS:
      const {
        collection,
        category,
        subcategory,
        size,
        continuos,
        fitting,
        closure,
        hood,
        padding,
        pockets,
        reversible,
        sleeves,
        sizes,
      } = action.payload.filters;

      let newCollection,
        newCategory,
        newSubcategory,
        newFitting,
        newClosure,
        newHood,
        newPadding,
        newPockets,
        newReversible,
        newSleeves;

      if (state.collectionFilterList && state.collectionFilterList.length > 0) {
        newCollection = [
          ...state.collectionFilterList.map((cf) => {
            const hit = collection?.find((c) => c.id === cf.id);
            if (!hit) {
              cf.disabled = true;
            } else {
              cf.disabled = false;
            }
            return { ...cf };
          }),
        ];
      } else {
        newCollection = collection ? [...collection] : [];
      }

      if (state.categoryFilterList && state.categoryFilterList.length > 0) {
        newCategory = [
          ...state.categoryFilterList.map((cf) => {
            const hit = category?.find((c) => c.id === cf.id);
            if (!hit) {
              cf.disabled = true;
            } else {
              cf.disabled = false;
            }
            return { ...cf };
          }),
        ];
      } else {
        newCategory = category ? [...category] : [];
      }

      if (
        state.productTypeFilterList &&
        state.productTypeFilterList.length > 0
      ) {
        newSubcategory = [
          ...state.productTypeFilterList.map((pf) => {
            const hit = subcategory?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newSubcategory = subcategory ? [...subcategory] : [];
      }

      if (state.fittingFilterList && state.fittingFilterList.length > 0) {
        newFitting = [
          ...state.fittingFilterList.map((pf) => {
            const hit = fitting?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newFitting = fitting ? [...fitting] : [];
      }

      if (state.closureFilterList && state.closureFilterList.length > 0) {
        newClosure = [
          ...state.closureFilterList.map((pf) => {
            const hit = closure?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newClosure = closure ? [...closure] : [];
      }

      if (state.hoodFilterList && state.hoodFilterList.length > 0) {
        newHood = [
          ...state.hoodFilterList.map((pf) => {
            const hit = hood?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newHood = hood ? [...hood] : [];
      }

      if (state.paddingFilterList && state.paddingFilterList.length > 0) {
        newPadding = [
          ...state.paddingFilterList.map((pf) => {
            const hit = padding?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newPadding = padding ? [...padding] : [];
      }

      if (state.pocketsFilterList && state.pocketsFilterList.length > 0) {
        newPockets = [
          ...state.pocketsFilterList.map((pf) => {
            const hit = pockets?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newPockets = pockets ? [...pockets] : [];
      }

      if (state.reversibleFilterList && state.reversibleFilterList.length > 0) {
        newReversible = [
          ...state.reversibleFilterList.map((pf) => {
            const hit = reversible?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newReversible = reversible ? [...reversible] : [];
      }

      if (state.sleevesFilterList && state.sleevesFilterList.length > 0) {
        newSleeves = [
          ...state.sleevesFilterList.map((pf) => {
            const hit = sleeves?.find((c) => c.id === pf.id);
            if (!hit) {
              pf.disabled = true;
            } else {
              pf.disabled = false;
            }
            return { ...pf };
          }),
        ];
      } else {
        newSleeves = sleeves ? [...sleeves] : [];
      }

      return {
        ...state,
        collectionFilterList: newCollection,
        categoryFilterList: newCategory,
        productTypeFilterList: newSubcategory,
        colorFilterList: action.payload.filters.color,
        sizeFilterList: sizes,
        continuousFilterList: continuos,
        fittingFilterList: newFitting,
        closureFilterList: newClosure,
        hoodFilterList: newHood,
        paddingFilterList: newPadding,
        pocketsFilterList: newPockets,
        reversibleFilterList: newReversible,
        sleevesFilterList: newSleeves,
        loadingFilters: false,
      };

    case yodaCatalogueConstants.GETFILTERS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loadingFilters: false,
      };

    case yodaCatalogueConstants.CLEAR_ORDER_CATALOG:
      tmpCatalogueItemDetails = {};
      tmpItemCatalog = {};
      return {
        ...state,
        itemCatalog: {},
        catalogueItemDetails: {},
        catalogueItemDetailsSwap: {},
        collectionFilterList: [],
        categoryFilterList: [],
        productTypeFilterList: [],
        colorFilterList: [],
        sizeFilterList: [],
        continuousFilterList: [],
        fittingFilterList: [],
        closureFilterList: [],
        hoodFilterList: [],
        paddingFilterList: [],
        pocketsFilterList: [],
        reversibleFilterList: [],
        sleevesFilterList: [],
      };

    case yodaCatalogueConstants.CLEAR_SWAP_ITEMS:
      return {
        ...state,
        catalogueItemDetailsSwap: {},
      };
    default:
      return state;
  }
};

export default catalogueReducer;
